const uiConstants = {
  CHANGE_PAGE_TITLE: 'PAGE_TITLE',
  CHANGE_DARK_MODE: 'CHANGE_DARK_MODE',
  CHANGE_DICTIONNARY: 'CHANGE_DICTIONNARY',
  CHANGE_DICTIONNARY_ALIGN: 'CHANGE_DICTIONNARY_ALIGN',
  SET_CURRENT_GROUP: 'UI_SET_CURRENT_GROUP',
};

export default uiConstants;
